import { Model } from 'app/model/backendmodel';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { DynamicsCrmCopySource } from 'app/model/pipeline/copysource/dynamics-crm.copysource';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DynamicsCrmCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class DynamicsCrmCopySourceAdapter extends CopySourceAdapter<DynamicsCrmCopySource, Model.DynamicsCrmSource> {
    protected override async _toResource(copySource: DynamicsCrmCopySource): Promise<Model.DynamicsCrmSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(DynamicsCrmCopySource).name);
    }

    protected override async _toModel(
        resource: Model.DynamicsCrmSource,
        copyActivity: CopyActivity
    ): Promise<DynamicsCrmCopySource> {
        return this._toTabularModel(resource, copyActivity, DynamicsCrmCopySource.MODEL);
    }
}
